import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { Box, CircularProgress } from '@mui/material'; // Para o spinner

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  // --- CORREÇÃO: Usar o estado isLoading ---
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  // Se estivermos verificando a autenticação, mostre um spinner
  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  // Se a verificação terminou e o usuário não está autenticado, redirecione
  if (!isAuthenticated) {
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }

  // Se a verificação terminou e o usuário está autenticado, mostre a página
  return <>{children}</>;
};

export default ProtectedRoute;